export const BASE_URL = '';

export const PATHS = {
  BASE_URL,
};
